export const metaInfo = {
  metaInfo() {
    const title = this.globalDataArray.siteInfo.title
    let description = ''
    let keywords = ''

    if (this.globalDataArray.siteNavigation[0].description != '' && this.globalDataArray.siteNavigation[0].description != null) {
      description = this.globalDataArray.siteNavigation[0].description
    } else {
      description = this.globalDataArray.siteInfo.description
    }
    if (this.globalDataArray.siteNavigation[0].keywords != '' && this.globalDataArray.siteNavigation[0].keywords != null) {
      keywords = this.globalDataArray.siteNavigation[0].keywords
    } else {
      keywords = this.globalDataArray.siteInfo.keywords
    }
    return {
      title: title,
      meta: [
        { vmid: 'description', name: 'description', content: description },
        { vmid: 'keywords', name: 'keywords', content: keywords }
      ]
    }
  }
}
